import Vue from 'vue';
import messagetemplate from '@telexpress/vue-messagetemplate';
import '@telexpress/vue-messagetemplate/dist/vue-messagetemplate.css';

Vue.use(messagetemplate, { gatewayUrl: Vue.env.VUE_APP_APIPATH_GATEWAYSERVICE, externalToolAPIUrl: Vue.env.VUE_APP_ExternalToolApi, PDIUrl: Vue.env.VUE_APP_PDI_DOMAIN });
